import React from "react";
import "./ApprovalForm.scss";
import { ApprovalHeaderForm } from "./ApprovalHeaderForm";
import { ApprovalDetailsForm } from "./ApprovalDetailsForm";
import { ContactDetailsForm } from "./ContactDetailsForm";
import { RepresentativeDetailsForm } from "./RepresentativeDetailsForm";

export const ApprovalForm: React.FC = () => {
  return (
    <div className="request-approval-form-container">
      <ApprovalHeaderForm />
      <ContactDetailsForm />
      <RepresentativeDetailsForm />
      <ApprovalDetailsForm />
    </div>
  );
};
